import { render, staticRenderFns } from "./FooterArea.vue?vue&type=template&id=d6bf0a40&scoped=true&"
import script from "./FooterArea.vue?vue&type=script&lang=js&"
export * from "./FooterArea.vue?vue&type=script&lang=js&"
import style0 from "./FooterArea.vue?vue&type=style&index=0&id=d6bf0a40&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6bf0a40",
  null
  
)

export default component.exports